import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { Button } from "@material-ui/core";
import { Marker, Popup } from "react-leaflet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobeEurope, faStreetView } from "@fortawesome/free-solid-svg-icons";

import LOGO_VILLE from "../../../../assets/images/logo_ville.png";

import { Radio } from "../../../../services";
import { IconTarget } from "./icons";

const MarkerRadioVN = ({ positionMarkerRadio, resetMarkerState, enqueueSnackbar }) => {
  const [hasEligRadioResult, setHasEligRadioResult] = useState(false);
  const [isEligibleRadio, setIsEligibleRadio] = useState(false);
  const [abortEligRadio, setAbortEligRadio] = useState(new AbortController());

  const onClickEligRadio = async position => {
    let result;
    const [lat, long] = [...position];

    abortEligRadio.abort();
    const abort = new AbortController();
    setAbortEligRadio(abort);

    Radio.getEligibiliteRadio(lat, long, abort)
      .then(response2 => {
        result = response2[0].resultat === "VENDEE NUMERIQUE";
        setHasEligRadioResult(true);
        setIsEligibleRadio(result);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  useEffect(() => {
    setHasEligRadioResult(false);
    setIsEligibleRadio(false);
  }, [resetMarkerState]);

  useEffect(() => () => abortEligRadio.abort(), []);

  return (
    <Marker key="eligRadioMarker" position={positionMarkerRadio} icon={IconTarget}>
      <Popup maxWidth={260} autoPan={false}>
        {!hasEligRadioResult && (
          <>
            <div className="alignCenter">
              <Button
                className="markerButtonDetail"
                startIcon={<FontAwesomeIcon icon={faStreetView} />}
                onClick={() => onClickEligRadio(positionMarkerRadio)}
              >
                Testez votre éligibilité radio
              </Button>
            </div>
            <div className="alignCenter">
              {positionMarkerRadio && (
                <span>
                  <FontAwesomeIcon icon={faGlobeEurope} style={{ marginRight: "10px" }} />
                  {`${positionMarkerRadio[0].toString().slice(0, 9)} (lat)`} ,{" "}
                  {`${positionMarkerRadio[1].toString().slice(0, 9)} (long)`}
                </span>
              )}
            </div>
          </>
        )}
        {hasEligRadioResult && (
          <>
            {isEligibleRadio ? (
              <div>
                <p className="popupTitle popupTitleColor">
                  Vous êtes couverts par le réseau THD Radio de Vendée Numérique.
                </p>
                <p>Ce réseau, déployé par Vendée Numérique, propose des débits de 8 à 30 Mb/s.</p>
                <p>
                  Pour vous abonner à ce réseau, il suffit de consulter la liste des{" "}
                  <a
                    href="https://www.vendeenumerique.fr/operateurs-thd-radio/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    opérateurs partenaires de Vendée Numérique.
                  </a>
                </p>
              </div>
            ) : (
              <div className="popupTitle popupTitleColor">
                Vous n&apos;êtes pas couverts par le réseau THD Radio de Vendée Numérique.
              </div>
            )}
            <div>
              <img
                className="logoVille"
                src={LOGO_VILLE}
                alt="Représentation d'une ville connectée"
              />
            </div>
          </>
        )}
      </Popup>
    </Marker>
  );
};

MarkerRadioVN.propTypes = {
  positionMarkerRadio: propTypes.array.isRequired,
  resetMarkerState: propTypes.bool.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(MarkerRadioVN);
